import Vue from "vue";
import App from "./App.vue";
import router from "./router";
import store from "./store";
import ElementUI from "element-ui";
import locale from "element-ui/lib/locale/lang/it";
import "element-ui/lib/theme-chalk/index.css";
import * as Sentry from "@sentry/vue";
import { Integrations } from "@sentry/tracing";
import moment from "moment";
import "moment/locale/it";
import vuemoment from "vue-moment";
import * as VueGoogleMaps from "vue2-google-maps";

Sentry.init({
  Vue,
  dsn: process.env.VUE_APP_SENTRY_DSN,
  integrations: [new Integrations.BrowserTracing()],
  tracesSampleRate: process.env.VUE_APP_SENTRY_RATE,
  environment: process.env.VUE_APP_SENTRY_ENV,
});

Vue.use(VueGoogleMaps, {
  load: {
    key: process.env.VUE_APP_MAPS_KEY,
    libraries: "places",
  },
});

Vue.config.productionTip = false;
Vue.use(ElementUI, { locale });

Vue.use(vuemoment, { moment });

new Vue({
  router,
  store,
  render: (h) => h(App),
}).$mount("#app");
